import { configureStore } from '@reduxjs/toolkit';
import ticketReducer from './slices/ticketSlice';

export const store = configureStore({
  reducer: {
    tickets: ticketReducer, // 티켓 상태 관리 reducer
  },
});

export default store;
